module.exports = require("@ember/component/template-only");